import { create } from "zustand";
import { toastError } from "../../Helpers/toasts";
import MainGroupsRepository from "../../Repositories/Groups/MainGroupsRepository";
import ExamFiledStudentsRepository from "../../Repositories/Reports/ExamFiledStudentsStoreRepository";

export const useExamFiledStudentsStore = create((set) => ({
  results: null,
  reasoning: null,
  absences_count: null,
  startDate: null,
  startDate: null,
  endDate: null,
  endDate: null,
  pagination: null,
  branches: null,
  isLoading: false,
  queryParams: {
    page: 1,
  },

  setLoading: (status) => {
    set({
      isLoading: status,
    });
  },

  updateParams: (paramItem) => {
    set((prevState) => ({
      queryParams: { ...prevState.queryParams, ...paramItem },
    }));
  },

  onReload: async (queryString) => {
    const { data, status, nonFieldErrors } =
      await ExamFiledStudentsRepository.studentsList(queryString);
    if (status) {
      set({
        results: data.results.student_results,
        absences_count: data.results.results_count,
        // reasoning: data.results.filterset.cards,
        pagination: { page_count: data.pages_count || 1 },
        queryParams: { page: 1 },
      });
    } else toastError(nonFieldErrors);
  },
  getBranches: async () => {
    const { data, status } = await MainGroupsRepository.getAllBranches()
    if (status) {
      set({
        branches: data,
      })
    }
  },
  loadItems: async (queryString) => {
    const { data, status, nonFieldErrors } =
      await ExamFiledStudentsRepository.studentsList(queryString);
    if (status) {
      set({
        results: data.results.student_results,
        absences_count: data.results.results_count,
        pagination: { page_count: data.pages_count || 1 },
      });
    } else toastError(nonFieldErrors);
  },
}));
